(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('.pz-article-gallery').forEach(initGallery);
  });

  function initGallery(root) {
    if (root.dataset.pzAgInit) return;
    root.dataset.pzAgInit = '1';

    var scroller = root.querySelector('[data-pz-ag-scroller]');
    var slides = scroller ? Array.prototype.slice.call(scroller.querySelectorAll('.pz-article-gallery__slide')) : [];
    if (!scroller || !slides.length) return;

    var prev = root.querySelector('[data-pz-ag-prev]');
    var next = root.querySelector('[data-pz-ag-next]');
    var current = root.querySelector('[data-pz-ag-current]');

    var idx = 0;

    function centerOf(el) {
      var r = el.getBoundingClientRect();
      return r.left + r.width / 2;
    }

    function findActive() {
      var cx = window.innerWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(centerOf(s) - cx);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }

    function updateState() {
      idx = findActive();
      if (current) current.textContent = String(idx + 1);
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx === slides.length - 1;
    }

    function go(i) {
      var clamped = Math.max(0, Math.min(slides.length - 1, i));
      slides[clamped].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });

    var scrollTimer = null;
    scroller.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateState, 60);
    }, { passive: true });

    updateState();

    // ────── Lightbox ──────
    var triggers = root.querySelectorAll('[data-pz-ag-lightbox-open]');
    if (!triggers.length) return;

    var urls = Array.prototype.map.call(triggers, function (t) { return t.getAttribute('data-full') || t.src; });
    var alts = Array.prototype.map.call(triggers, function (t) { return t.alt || ''; });

    Array.prototype.forEach.call(triggers, function (t, i) {
      t.addEventListener('click', function () { openLightbox(i); });
    });

    var lb = null;
    var lbIdx = 0;

    function buildLightbox() {
      lb = document.createElement('div');
      lb.className = 'pz-ag-lightbox';
      lb.setAttribute('aria-hidden', 'true');
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      var _agEn = (document.documentElement.getAttribute('lang') || 'it').toLowerCase().indexOf('en') === 0;
      var _agT = _agEn
        ? { gallery: 'Image gallery', prev: 'Previous', next: 'Next', close: 'Close',
            instr: 'Use the left and right arrows to browse the images, ESC to close.' }
        : { gallery: 'Galleria immagini', prev: 'Precedente', next: 'Successiva', close: 'Chiudi',
            instr: 'Usa le frecce sinistra e destra per navigare tra le immagini, ESC per chiudere.' };
      lb.setAttribute('aria-label', _agT.gallery);
      lb.setAttribute('aria-describedby', 'pz-ag-lb-instr');
      var navHtml = urls.length > 1
        ? '<button type="button" class="pz-ag-lightbox__nav pz-ag-lightbox__nav--prev" aria-label="' + _agT.prev + '">'
        + '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M15 18l-6-6 6-6"/></svg>'
        + '</button>'
        + '<button type="button" class="pz-ag-lightbox__nav pz-ag-lightbox__nav--next" aria-label="' + _agT.next + '">'
        + '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M9 6l6 6-6 6"/></svg>'
        + '</button>'
        + '<div class="pz-ag-lightbox__counter" aria-live="polite"><span data-lb-cur>1</span> / ' + urls.length + '</div>'
        : '';
      lb.innerHTML = '<div class="pz-ag-lightbox__stage">'
        + '<span id="pz-ag-lb-instr" class="visually-hidden">' + _agT.instr + '</span>'
        + '<button type="button" class="pz-ag-lightbox__close" aria-label="' + _agT.close + '">'
        + '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" d="M6 6l12 12M18 6L6 18"/></svg>'
        + '</button>'
        + navHtml
        + '<img class="pz-ag-lightbox__img" alt="">'
        + '</div>';
      document.body.appendChild(lb);

      lb.querySelector('.pz-ag-lightbox__close').addEventListener('click', close);
      lb.addEventListener('click', function (e) {
        if (e.target === lb) close();
      });
      var p = lb.querySelector('.pz-ag-lightbox__nav--prev');
      var n = lb.querySelector('.pz-ag-lightbox__nav--next');
      if (p) p.addEventListener('click', function () { goLb(-1); });
      if (n) n.addEventListener('click', function () { goLb(1); });
      document.addEventListener('keydown', keyHandler);
    }

    function keyHandler(e) {
      if (!lb || lb.getAttribute('aria-hidden') === 'true') return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') goLb(-1);
      else if (e.key === 'ArrowRight') goLb(1);
    }

    function render() {
      var img = lb.querySelector('.pz-ag-lightbox__img');
      img.src = urls[lbIdx];
      img.alt = alts[lbIdx];
      var cur = lb.querySelector('[data-lb-cur]');
      if (cur) cur.textContent = String(lbIdx + 1);
    }

    function openLightbox(i) {
      if (!lb) buildLightbox();
      lbIdx = i;
      render();
      lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      if (!lb) return;
      lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function goLb(delta) {
      lbIdx = (lbIdx + delta + urls.length) % urls.length;
      render();
    }
  }
})();
